const content = [
  {
    header: 'Even with our generous free plan',
    headerColor: '#F4ED70',
    explanation:
      '<ul>' +
      '<li>• Benefit from <strong>unlimited learner</strong> engagements</li>' +
      '<li>• Share mini-courses & landing page with link</li>' +
      '<li>• Embed mini-courses & collections on webpages</li>' +
      '<li>• Issue digital badges to your learners based on success</li>' +
      '</ul>',
    buttonText: 'Continue',
    skip: true,
  },
  {
    header: 'With the Pro plan:',
    headerColor: 'none',
    explanation:
      '<ul>' +
      '<li>• No limit for mini-courses & landing pages</li>' +
      '<li>• Benefit from AI capabilities</li>' +
      '<li>• Customize learner access</li>' +
      '<li>• Utilize features like certification, CNAME, etc.</li>' +
      '</ul>',
    buttonText: 'Continue',
    skip: true,
  },
  {
    header: 'With the Elite Plan:',
    headerColor: 'none',
    explanation:
      '<ul>' +
      '<li>• Get the highest AI credits</li>' +
      '<li>• Export courses to SCORM</li>' +
      '<li>• Present in-product academy with in-app authentication</li>' +
      '<li>• Present academy directly in Intercom Messenger</li>' +
      '</ul>',
    buttonText: 'Continue',
    skip: true,
  },
]
export default content
